import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { extractMapSrc } from "../../utils/format";

const MinpakuDetail = () => {
  const { id } = useParams();
  const nav = useNavigate();
  const [item, setItem] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isToggling, setIsToggling] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("admin_jwt");
    fetch(`/api/admin/minpaku?id=${encodeURIComponent(id)}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
      },
    })
      .then((r) => {
        if (!r.ok) throw new Error("取得失敗");
        return r.json();
      })
      .then(setItem)
      .catch(() => setItem(null));
  }, [id]);

  // 削除
  const handleDelete = async () => {
    if (isDeleting) return; // 二重削除ガード
    if (!window.confirm("この物件を削除しますか？")) return;
    setIsDeleting(true);
    const token = localStorage.getItem("admin_jwt");
    try {
      const res = await fetch(`/api/admin/minpaku?id=${encodeURIComponent(id)}`, {
        method: "DELETE",
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      });
      if (res.ok) {
        alert("削除しました");
        nav("/admin/minpaku");
      } else {
        alert("削除に失敗しました");
      }
    } catch (err) {
      console.error(err);
      alert("エラーが発生しました");
    } finally {
      setIsDeleting(false);
    }
  };

  // 掲載/非公開の切替
  const handleTogglePublish = async () => {
    if (isToggling || !item) return;
    setIsToggling(true);
    const token = localStorage.getItem("admin_jwt");
    const nextPublished = item.published === false;
    try {
      const res = await fetch("/api/admin/minpaku", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ ...item, id, published: nextPublished }),
      });
      if (res.ok) {
        setItem((prev) => ({ ...prev, published: nextPublished }));
      } else {
        alert("公開状態の変更に失敗しました");
      }
    } catch (err) {
      console.error(err);
      alert("エラーが発生しました");
    } finally {
      setIsToggling(false);
    }
  };

  if (!item) return <p className="p-6">読み込み中…</p>;

  const isPublished = item.published !== false;

  return (
    <div className="adm-card max-w-3xl mx-auto">
      <div className="flex items-center gap-3 mb-2">
        <h1 className="text-2xl font-bold text-gray-800">{item.name}</h1>
        <span
          className={`text-xs px-2 py-0.5 rounded-full ${
            isPublished
              ? "bg-green-100 text-green-700"
              : "bg-gray-200 text-gray-600"
          }`}
        >
          {isPublished ? "掲載中" : "非公開"}
        </span>
      </div>
      <p className="text-sm text-gray-500 mb-4">
        登録日：{" "}
        {item.createdAt
          ? new Date(item.createdAt).toLocaleDateString("ja-JP", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })
          : ""}
      </p>
      <div className="mb-4 whitespace-pre-wrap">{item.body}</div>

      {item.photos?.length > 0 && (
        <div className="grid grid-cols-2 gap-2 mb-4">
          {item.photos.map((url) => (
            <img key={url} src={url} alt="物件写真" className="w-full object-cover" />
          ))}
        </div>
      )}

      {item.reservationUrls?.length > 0 && (
        <div className="mb-4">
          <h2 className="font-semibold">予約リンク</h2>
          <ul className="list-disc list-inside">
            {item.reservationUrls.map((r, i) => (
              <li key={i}>
                <a href={r.url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                  {r.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}

      {item.mapUrl && (
        <div className="mb-4">
          <h2 className="font-semibold mb-2">地図</h2>
          <iframe
            src={extractMapSrc(item.mapUrl)}
            width="100%"
            height="300"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            title="物件地図"
          />
        </div>
      )}

      <div className="flex items-center gap-2 pt-4 border-t border-gray-100">
        <Link to={`/admin/minpaku/${id}/edit`} className="adm-btn-warn">
          編集
        </Link>
        <button
          type="button"
          onClick={handleTogglePublish}
          disabled={isToggling}
          className={isPublished ? "adm-btn-sub" : "adm-btn"}
        >
          {isToggling ? "変更中…" : isPublished ? "非公開にする" : "掲載する"}
        </button>
        <button
          onClick={handleDelete}
          disabled={isDeleting}
          className="adm-btn-danger"
        >
          {isDeleting ? "削除中…" : "削除"}
        </button>
        <Link
          to="/admin/minpaku"
          className="ml-auto text-sm text-gray-600 hover:underline"
        >
          ← 一覧に戻る
        </Link>
      </div>
    </div>
  );
};

export default MinpakuDetail;
